import { EOnboaringFormStep } from '@constants';

import { useSignWellScript } from '../../../hooks/useSignWellScript';

import { LoadingContract } from './components/LoadingContract';
import { LoadingContractValidaton } from './components/LoadingContractValidation';
import { SignContract } from './components/SignContract';
import { SignedContractStepWrapper } from './SignedContractStep.styles';

import { useOnboardingFormLogic } from '@/hooks';
import { useProfile } from '@/store';

export const SignContractStep: React.FC = () => {
  const { loadingAfterContract, currentStep } = useOnboardingFormLogic();
  const { isScriptLoaded } = useSignWellScript();
  const { profile } = useProfile();

  if (currentStep !== EOnboaringFormStep.SIGN_CONTRACT || !profile) return null;

  const hasAllRequiredFields =
    profile.legalId &&
    profile.birthday &&
    profile.tags?.length &&
    profile.name &&
    profile.lastName &&
    profile.email;

  if (loadingAfterContract) {
    return (
      <SignedContractStepWrapper>
        <LoadingContractValidaton />
      </SignedContractStepWrapper>
    );
  }

  if (!isScriptLoaded || !hasAllRequiredFields) {
    return (
      <SignedContractStepWrapper>
        <LoadingContract />
      </SignedContractStepWrapper>
    );
  }

  return (
    <SignedContractStepWrapper>
      <SignContract />
    </SignedContractStepWrapper>
  );
};
